import './about.css'
import Typing from 'react-typing-animation';
import Typical from 'react-typical'
import pic from '../assets/man.svg'
import { motion} from "framer-motion";
const About = ()=>{
    return(
        <section
        data-aos="fade-right"
        className="About-container"
        name="About"
        id="About"
      >
        <div>
             <h1 className='heading'>About Me</h1>
             <h1>
             <Typical
        steps={[
            'User Programmer',2000,
            'Web Designer', 2000,
         'Web Developer', 2000,
         'React Js Developer',2000,
         'React Native Developer',2000,
         'Open Source Contributor',2000,
         'AIOT-enthusiast',2000,
         'Rustacean',2000,
         'Data Science Learner',2000
            ]}
        loop={Infinity}
        
        className="aboutser"
      />
      </h1>
      <div className="maain">
            <div className="sub1">
            <p className='paraText'>
                    
                    My name is Syed Usama Ali -- An enthusiastic developer who is passionate about new technologies. I am an undergraduate student of Mechanical Engineering in Ned University of Engineering & Technology , Karachi Pakistan.
                    <Typing speed={100} >I am currently enrolled in IOT Q4 and Applied Data Science from Piaic and DSC NED respectively.
Recently, I have completed Web and Mobile Hybrid App Development course from SMIT and now working as a freelancer.


I am an enthusiastic, self-motivated, reliable, responsible and hard working person, a mature team worker and adaptable to all challenging situations, able to work under pressure and adhere to strict deadlines.

                </Typing>
                </p>
            </div>

            <div className="sub2">   
            <motion.div
        // className="svg-container"
        animate={{ translateY: [-50, 10, -10, 10] }}
        transition={{ yoyo: Infinity, duration: 6 }}
      >
         <img src={pic} className="pic" alt="pic"/>
     
      </motion.div>
      </div>
            
           
      </div>
  
               
        </div>
        </section>
    )
}
export default About;